import Pathes from '@/helpers/pathes';
import axios from '@/axios-api';
import { getQuery } from '@/helpers/utils';

export const marketingService = {
  referralCode: () => axios.get(Pathes.Referrals.getCode),
  bonusGroups: () => axios.get(Pathes.User.bonusGroup),
  increasedIncome: () => axios.get(Pathes.Investing.increasedIncome),
  referrals: params => axios.get(Pathes.Referrals.list + getQuery(params)),
};
